import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { environment } from './../../../env';
import { loaderAction } from '../../../redux/actions/Index';
import PdfDownload from './PdfDownload';
import PriceFormater from '../../../Helper/PriceFormater';
import { Eye } from '@phosphor-icons/react';
import moment from 'moment';

const ProposalModal = ({ data }, ...props) => {
  const [modal, setModal] = useState(false);
  const [investors, SetInvestors] = useState();
  const total = (Number(data.rent_price) + Number(data.varai) + Number(data.maintenance) + Number(data.extra_amenities) + Number(data.other_charges)).toFixed(2)
  const dispatch = useDispatch();
  console.log("=-=-=-=-=-=-=-", data.created_at)
  const getProposalInvestors = async (data) => {
    dispatch(loaderAction(true))
    try {
      await axios.get(`${environment.baseUrl}proposal-investors/${data}`).then((proposal) => {
        SetInvestors(proposal.data);
        dispatch(loaderAction(false))
      })
    }
    catch (err) {
      dispatch(loaderAction(false))
      console.log(err);
    }
  }


  useEffect(() => {
    getProposalInvestors(data.id);
  }, [])
  const toggle = () => setModal(!modal);

  return (
    <div>
      <button onClick={toggle} className="icon-bg-green border-0 px-2 py-3 rounded"><Eye size="28" className='icon-color-green' /></button>
      <Modal isOpen={modal} toggle={toggle} size="lg" centered >
        <ModalBody className='fs-1'>
          <div className="container px-5" >
            <header className='text-center py-3'>
              <h2 className='fs-1 text-base-color title-font-800 pb-2'>{data?.project?.name}</h2>
              <h2 className='fs-2 base-font-700'>Proposal Letter</h2>
            </header>
            <main>
              <div className="pt-5">
                {data?.check_inclusive == false ?
                  <table className="table fs-4 border border-2 border-dark table-hover" id='my-table1'>
                    <thead className='fs-4'>
                      <tr className='fs-2'>
                        <th scope="col" className="fs-4 title-font-500">Rent Price</th>
                        <th scope="col" className="fs-4 title-font-500">Varai</th>
                        <th scope="col" className="fs-4 title-font-500">Maintenance</th>
                        <th scope="col" className="fs-4 title-font-500">Extra Amenities</th>
                        <th scope="col" className="fs-4 title-font-500">Other Charges</th>
                        <th scope="col" className="fs-4 title-font-500">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="fs-4">{data?.rent_price}</td>
                        <td className="fs-4">{data?.varai}</td>
                        <td className="fs-4">{data?.maintenance}</td>
                        <td className="fs-4">{data?.extra_amenities}</td>
                        <td className="fs-4">{data?.other_charges}</td>
                        <td className="fs-4">{total}</td>
                      </tr>
                    </tbody>
                  </table> :

                  <p className='fs-2 text-base-color base-font-700'>The Total Amount with All Inclusive is {<PriceFormater price={total} />} Rs.</p>}
                <div className="d-flex justify-content-center align-items-center">
                  <h1 className="fs-1 title-font-700 text-base-color py-4">Letter Of Intent</h1>
                </div>
                <table className='fs-4 title-font-600 letter-table border border-dark' id='my-table'>
                  <tbody>
                    <tr>
                      <td>
                        1
                      </td>
                      <td>
                        Party Name
                      </td>
                      <td>
                        {data?.name_of_company}
                      </td>
                    </tr>
                    {/* <tr>
                      <td>
                        {data?.lessor_name}
                      </td>
                    </tr> */}
                    <tr>
                      <td >
                        2
                      </td>
                      <td >
                        Party Address
                      </td>
                      <td>
                        {data?.register_address}
                      </td>
                    </tr>
                    <tr>
                      <td >
                        3
                      </td>
                      <td >
                        Project Name:
                      </td>
                      <td>
                        {data?.project?.name}
                      </td>
                    </tr>
                    <tr>
                      <td >
                        4
                      </td>
                      <td >
                        Project Location:
                      </td>
                      <td>
                        {`${data?.project?.address1}, ${data?.project?.city?.city_name}, ${data?.project?.state}, ${data?.project?.pincode}`}
                      </td>
                    </tr>
                    <tr>
                      <td >
                        5
                      </td>
                      <td >
                        Building No:
                      </td>
                      <td>
                        {data?.building_no?.building_no}
                      </td>
                    </tr>
                    <tr>
                      <td >
                        6
                      </td>
                      <td >
                        Gala No From & To
                      </td>
                      <td>

                      </td>
                    </tr>
                    <tr>
                      <td >
                        7
                      </td>
                      <td >
                        Builtup Area
                      </td>
                      <td>
                        {data?.required_area} Sq. ft.
                      </td>
                    </tr>
                    <tr>
                      <td >
                        8
                      </td>
                      <td >
                        Carpet Area
                      </td>
                      <td>
                        {(parseFloat(data?.required_area) / 1.25).toFixed(2)} Sq. ft.
                      </td>
                    </tr>
                    <tr>
                      <td >
                        9
                      </td>
                      <td >
                        Rent and Other Charges
                      </td>
                      <td>
                        {data?.rentalsqft}
                      </td>
                    </tr>
                    <tr>
                      <td >
                        10
                      </td>
                      <td >
                        Taxes
                      </td>
                      <td>
                        {data?.taxes}
                      </td>
                    </tr>
                    <tr>
                      <td >
                        11
                      </td>
                      <td >
                        Refundable Security Deposit
                      </td>
                      <td>
                        {data?.refundable_security}
                      </td>
                    </tr>
                    <tr>
                      <td >
                        12
                      </td>
                      <td >
                        Tenure
                      </td>
                      <td>
                        {data?.tenure}
                      </td>
                    </tr>
                    <tr>
                      <td >
                        13
                      </td>
                      <td >
                        Lock In Period
                      </td>
                      <td>
                        {data?.lock_in_period}
                      </td>
                    </tr>
                    <tr>
                      <td >
                        14
                      </td>
                      <td >
                        Notice Period
                      </td>
                      <td>
                        {data?.notice_period}
                      </td>
                    </tr>
                    <tr>
                      <td >
                        15
                      </td>
                      <td >
                        Increment in Rent & Maintenance
                      </td>
                      <td>
                        {data?.escalation_maintenance}
                      </td>
                    </tr>
                    <tr>
                      <td >
                        16
                      </td>
                      <td >
                        Payment Terms
                      </td>
                      <td>
                        {data?.payment_terms}
                      </td>
                    </tr>
                    <tr>
                      <td >
                        17
                      </td>
                      <td >
                        Type of permission
                      </td>
                      <td>
                        {data?.licenses_approval}
                      </td>
                    </tr>
                    <tr>
                      <td >
                        18
                      </td>
                      <td >
                        Date of Possession
                      </td>
                      <td>
                        {moment(data?.possession_date).format('DD/MM/YYYY')}
                      </td>
                    </tr>
                    <tr>
                      <td >
                        19
                      </td>
                      <td >
                        Stamp Duty
                      </td>
                      <td>
                        {data?.stamp_duty}
                      </td>
                    </tr>
                    <tr>
                      <td >
                        20
                      </td>
                      <td >
                        Parking
                      </td>
                      <td>
                        {data?.parking_area}
                      </td>
                    </tr>
                    <tr>
                      <td >
                        21
                      </td>
                      <td >
                        Electricity
                      </td>
                      <td>
                        {data?.electricity_charges}
                      </td>
                    </tr>
                    <tr>
                      <td >
                        22
                      </td>
                      <td >
                        Water Supply
                      </td>
                      <td>
                        {data?.water_connection}
                      </td>
                    </tr>
                    {data?.additional_comments != 'null' && data?.additional_comments != '' &&
                      <tr>
                        <td >
                          23
                        </td>
                        <td >
                          Comment
                        </td>
                        <td>
                          {data?.additional_comments}
                        </td>
                      </tr>}
                    {data?.additional_comments1 != 'null' && data?.additional_comments1 != '' &&
                      <tr>
                        <td >
                          24
                        </td>
                        <td >
                          Comment 1
                        </td>
                        <td>
                          {data?.additional_comments1}
                        </td>
                      </tr>}
                    {data?.additional_comments2 != 'null' && data?.additional_comments2 != '' &&
                      <tr>
                        <td >
                          25
                        </td>
                        <td >
                          Comment 2
                        </td>
                        <td>
                          {data?.additional_comments2}
                        </td>
                      </tr>}
                    {data?.additional_comments3 != 'null' && data?.additional_comments3 != '' &&
                      <tr>
                        <td >
                          26
                        </td>
                        <td >
                          Comment 3
                        </td>
                        <td>
                          {data?.additional_comments3}
                        </td>
                      </tr>}
                  </tbody>
                </table>
              </div>
              <div className="text-end pt-5">
                <span className="fs-5 base-font-600">
                  Regards,
                </span>
                <h3 className='fs-3 base-font-700'>Sumeet Logistics</h3>
                <h3 className='fs-3 title-font-600'>Thank You 💕</h3>
              </div>

            </main>
          </div>
        </ModalBody>
        <ModalFooter className='d-flex justify-content-center align-items-center gap-5'>
          <Button type="button"
            className="border-radius-7 p-3 d-flex align-items-center buttons-outline"
            onClick={toggle}
          >
            <span className="fs-5 d-flex gap-3 title-font-600 px-3">
              Cancel
            </span></Button>
          <PdfDownload total={total} check_inclusive={data?.check_inclusive} date={data?.created_at} />
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default ProposalModal;